import { SVGProps } from 'react';

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="10"
    viewBox="0 0 20 10"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.707 0.292969L13.293 1.70697L15.586 3.99997H0V5.99997H15.586L13.293 8.29297L14.707 9.70697L19.414 4.99997L14.707 0.292969Z"
      fill="currentColor"
    />
  </svg>
);
